import { useMemo } from 'react';
const { dayjs } = window.sfp.scriptLibs;

const getUnavailableWorkshopIds = function (formElementValue, workshops) {
  const idMap = {};

  Object.keys(workshops).forEach((key) => {
    const isSelected = !!formElementValue[key];
    if (!isSelected) return;

    const selectedWorkshop = workshops[key];

    Object.keys(workshops).forEach((key2) => {
      if (key === key2) {
        return;
      }
      const desiredWorkshop = workshops[key2];

      // [ x ]
      //     [ y ]
      const selectedBeforeDesired =
        dayjs(selectedWorkshop.startDate).isBefore(desiredWorkshop.startDate) &&
        dayjs(selectedWorkshop.endDate).isSameOrBefore(
          desiredWorkshop.startDate
        );

      // [ y ]
      //     [ x ]
      const desiredBeforeSelected =
        dayjs(desiredWorkshop.startDate).isBefore(selectedWorkshop.startDate) &&
        dayjs(desiredWorkshop.endDate).isSameOrBefore(
          selectedWorkshop.startDate
        );

      const isAvailable = selectedBeforeDesired || desiredBeforeSelected;

      if (!isAvailable) {
        idMap[key2] = true;
      }
    });
  });

  return idMap;
};

export const useUnavailableWorkshopIds = function (
  formElementValue,
  workshops
) {
  return useMemo(
    function () {
      return getUnavailableWorkshopIds(formElementValue, workshops);
    },
    [formElementValue, workshops]
  );
};

/**
 * Returns a map of unavailable workshop ids by formElement id
 *
 * @param {any} formElements
 * @param {any} workshops
 */
const getUnavailableWorkshopIdsByFormElement = function (
  formElements,
  workshops
) {
  return Object.keys(formElements).reduce((acc, key) => {
    const formElement = formElements[key];
    const idMap = getUnavailableWorkshopIds(formElement, workshops);

    acc[key] = idMap;

    return acc;
  }, {});
};
